import { element } from '../../../util/element';

export default function template(data = {}) {
  const { errorMessage, url, urlTitle } = data;
  return element(
    'div#csr-oops-overlay',
    element('div.message', [
      errorMessage || 'Oops! The link testm 3you just clicked on is temporarily unavailable. Please close this window and try again.',
      url ? element('a.close', { href: url }, urlTitle) : '',
    ]),
  );
}
